import React, { useState } from "react";
import { DashboardIcon, HistoryIcon, OrdersIcon } from "../../../assets/icons";
import styles from "./ButtomNav.module.scss";
import ButtomNavButton, { BottomNavButtonProps } from "./ButtomNavButton";
import { getUserType } from "../../../guards/common/authentification-functions";
import { UserType } from "../../../model/userType";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

const ButtomNav = () => {
	const navigator = useNavigate();
	const location = useLocation();

	const handleButtonClick = (action?: () => void) => {
		action?.();
	};

	const dasboardLink = `/${ApplicationRoutes.CUSTOMER_BASE}/${ApplicationRoutes.CUSTOMER_DASHBOARD}`;
	const orderLink = `/${ApplicationRoutes.CUSTOMER_BASE}/${ApplicationRoutes.CUSTOMER_ORDERS}`;
	const paymentLink = `/${ApplicationRoutes.CUSTOMER_BASE}/${ApplicationRoutes.PAYMENTS}`;

	const tabButtons: BottomNavButtonProps[] = [
		{
			title: "Home",
			icon: <DashboardIcon height={24} />,
			route: dasboardLink,
			onClick: () => {
				navigator(dasboardLink);
			},
			isActive: false,
		},
		{
			title: "Orders",
			icon: <OrdersIcon height={24} />,
			route: orderLink,
			onClick: () => {
				navigator(orderLink);
			},
			isActive: false,
		},
		{
			title: "Payment",
			icon: <HistoryIcon height={24} />,
			route: paymentLink,
			onClick: () => {
				navigator(paymentLink);
			},
			isActive: false,
		},
		{ title: "Settings", icon: <DashboardIcon height={24} />, onClick: () => {}, isActive: false },
	];

	const returnButton = () => {
		let userType = getUserType();
		if (userType === UserType.Customer) {
			return tabButtons;
		}

		return [];
	};

	return (
		<div className={styles.container}>
			{returnButton()?.map((button, index) => (
				<ButtomNavButton
					key={index}
					isActive={location?.pathname === button?.route}
					title={button.title}
					icon={button.icon}
					onClick={() => handleButtonClick(button.onClick)}
				/>
			))}
		</div>
	);
};

export default ButtomNav;
